import React from "react";
import { useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";

import { useNavigate } from "react-router-dom";

function SecondaryNavbar() {
  const navigate = useNavigate();
  const { selectedLanguage, setSelectedLanguage } = useLanguage(); // Use the context

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdownLang = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };
  return (
    <>
      <img
        src={
          process.env.PUBLIC_URL + "/Logo/Black_logo-navbar_tablet 168x46.png"
        }
        alt="Logo"
        className="w-48 h-auto mx-auto mt-8 mb-0 cursor-pointer"
        onClick={() => navigate("/")}
      />
      <hr className="my-4 " />

      <div
        className="flex justify-end mt-4 mr-10 absolute top-20 right-10"
        onClick={toggleDropdownLang}
      >
        <img
          src={
            selectedLanguage === "th"
              ? process.env.PUBLIC_URL + "/mian/languages/Thailand.svg"
              : process.env.PUBLIC_URL + "/mian/languages/English.svg"
          }
          alt="Language"
          className="mr-2 w-8 "
        />
        {isDropdownOpen && (
          <div className="absolute top-8 right-15 bg-white shadow-md rounded-md p-2 w-16">
            <div
              className={`cursor-pointer relative text-gray-700 ${
                selectedLanguage === "th" ? "text-primary-900 font-light" : ""
              }`}
              onClick={() => handleLanguageChange("th")}
            >
              <img
                src={process.env.PUBLIC_URL + "/mian/languages/Thailand.svg"}
                alt="Thai"
                className="w-6 h-6 inline mr-2"
              />

              {selectedLanguage === "th" && (
                <span className="absolute right-0 top-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    className=""
                  >
                    <path
                      d="M7.16172 13.5002L2.88672 9.22519L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z"
                      fill="#1DAB59"
                    />
                  </svg>
                </span>
              )}
            </div>
            <div
              className={`cursor-pointer text-gray-700
               ${
                 selectedLanguage === "en" ? "text-primary-900 font-light" : ""
               }`}
              onClick={() => handleLanguageChange("en")}
            >
              <img
                src={process.env.PUBLIC_URL + "/mian/languages/English.svg"}
                alt="English"
                className="w-6 h-6 inline mr-2"
              />

              {selectedLanguage === "en" && (
                <span className="absolute right-2 bottom-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    className=""
                  >
                    <path
                      d="M7.16172 13.5002L2.88672 9.22519L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z"
                      fill="#1DAB59"
                    />
                  </svg>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SecondaryNavbar;
